module.exports = "/_next/static/images/caravan-line-bf692a42c7f96457aa786d3893eb36b8.svg";